import React from "react";
import {
  Box,
  Flex,
  Heading,
  IconOnePassBg,
  styled,
} from "@catchoftheday/cg-components";

const BgIcon = styled(IconOnePassBg)`
  mix-blend-mode: overlay;
`;

export const ModalContent: React.FC = ({ children }) => {
  return (
    <Flex
      zIndex={1000}
      flexDirection={{ xs: "column", md: "row" }}
      justifyContent="center"
      alignItems="center"
    >
      <Flex
        position="relative"
        alignItems={{ xs: "center", md: "flex-end" }}
        px={{ xs: "20px", md: "32px" }}
        backgroundColor="onePass.primaryDarker"
        alignSelf="stretch"
        justifyContent="center"
      >
        <Heading.h1
          fontSize={{ xs: "base", md: "2xl" }}
          textAlign={{ xs: "center", md: "left" }}
          color="textWhite"
          fontWeight="bold"
          fontFamily="onePass"
          mb={{ xs: undefined, md: "60px", lg: "90px" }}
        >
          Get FREE delivery on these great products!
        </Heading.h1>
        <Box
          display={{ xs: "none", md: "block" }}
          position="absolute"
          top={0}
          right={0}
          height="100%"
        >
          <BgIcon
            name="OnePass background"
            fill="white"
            width="auto"
            height={{ xs: "100%", md: "40%", lg: "50%" }}
            opacity={0.5}
            role="img"
          />
        </Box>
      </Flex>
      <Flex pt="12px" width={{ xs: "100%", md: "75%" }}>
        {children}
      </Flex>
    </Flex>
  );
};
